import React, { useContext, useEffect, useState } from "react";
import { useKBar } from "kbar";
import { useGetSearchMembersProfilesQuery } from "./PageSearch-generated.hooks";
import { AppContext } from "../../../../context/app";
import UserAvatar from "../../../common/UserAvatar/UserAvatar";
import _ from "lodash";

const DEBOUNCE_MS = 300;

function MembersSearch({ search }: { search: string }) {
  const { client } = useContext(AppContext);
  const kbar = useKBar();
  const [debouncedSearch, setDebouncedSearch] = useState(search);

  const { data: getSearchMembersQuery } = useGetSearchMembersProfilesQuery({
    variables: {
      getProfilesInput: {
        search: debouncedSearch,
        clientUuid: client.client_uuid || client.uuid,
        isStaff: undefined,
        membershipStatus: undefined,
        name: undefined,
      },
    },
    skip: debouncedSearch.length < 3,
  });

  useEffect(() => {
    const debouncedSetSearch = _.debounce(
      (searchValue) => setDebouncedSearch(searchValue),
      DEBOUNCE_MS,
    );
    debouncedSetSearch(search);

    return () => {
      debouncedSetSearch.cancel();
    };
  }, [search]);

  useEffect(() => {
    const membersToRegister =
      getSearchMembersQuery?.getProfiles?.map((member) => {
        return {
          id: member.userUuid,
          name: `${member.firstName} ${member.lastName} `,
          icon: <UserAvatar data={member} size="medium" />,
          subtitle: member.email,
          section: "people",
          keywords: member.phone,
          perform: () =>
            (window.location.pathname = `members/view/${member.userUuid}`),
        };
      }) || [];

    kbar.query.registerActions(membersToRegister);
  }, [getSearchMembersQuery?.getProfiles, kbar.query]);

  return <></>;
}

export default MembersSearch;
